module.exports = __webpack_public_path__ + "images/upgrade-prompts/bose.589868a7011a4e5de9d1.svg";